<script lang="ts" setup generic="T extends { id: number | string }">
type Props = {
  items: T[]
}

type Slots = {
  default(data: { item: T }): any
}

defineProps<Props>()
defineSlots<Slots>()
</script>

<template>
  <div
    class="grid tw-grid tw-grid-cols-1 tw-justify-center tw-gap-sm md:tw-grid-cols-4 md:tw-gap-lg lg:tw-grid-cols-6 lg:tw-gap-2xl"
  >
    <div
      v-for="item in items"
      :key="item.id"
      class="item tw-relative md:tw-col-span-2"
    >
      <slot name="default" v-bind="{ item }" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@screen md {
  .item:last-child:nth-child(2n + 1) {
    @apply max-lg:tw-col-end-4;
  }
}

@screen lg {
  .item:nth-last-child(2):nth-child(3n + 1) {
    @apply tw-col-end-4;
  }

  .item:last-child:nth-child(3n + 1) {
    @apply tw-col-end-5;
  }
}
</style>
